<template>
  <validation-observer ref="verifyForm" >
    <b-form class="auth-verify-form mt-2" @submit.prevent="validationForm">
      <!-- code -->
      <b-form-group label="Please enter the code" label-for="code">
        <validation-provider #default="{ errors }" name="code" rules="required">
          <b-form-input
            id="code"
            v-model="code"
            :state="errors.length > 0 ? false : null"
            name="register-code"
            placeholder="123456"
            autocomplete="on"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-button class="gradient-btn py-2" block  type="submit">
        send
      </b-button>
      <b-button variant="secondary py-2" block type="button" @click="resend">
        resend
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
  },
  data() {
    return {
      code: "",
      userData: JSON.parse(localStorage.getItem("userData")),
      loading: false,
      // validation rules
      required,
    };
  },

  methods: {
    async resend() {
      this.loading = true;
      try {
        const { data } = await this.$http.post("auth/user/email/resend");
      } catch (err) {}
      this.loading = false;
    },
    validationForm() {
      this.$refs.verifyForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("auth/user/email/verify", {
              code: this.code,
            });
            this.$router.push({ name: "user-dashboard" });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Welcome ${
                  this.userData.first_name + " " + this.userData.last_name
                }`,
                icon: "CoffeeIcon",
                variant: "success",
                text: `You have successfully logged in as ${
                  this.userData.first_name + " " + this.userData.last_name
                }. Now you can start to explore!`,
              },
            });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
